import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function CategoryPreview() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-end justify-between mb-12">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
              热门游戏分类
            </h2>
            <p className="text-sm md:text-base text-foreground-600">
              丰富的游戏类型，满足您的各种偏好
            </p>
          </div>
          <Link
            to="/category/all"
            className="text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer mt-4 sm:mt-0"
          >
            查看全部分类 →
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.id}`}
              className="group bg-background-100 rounded-2xl overflow-hidden cursor-pointer hover:bg-background-200/70 transition-colors"
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={cat.imageUrl}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2.5 mb-2">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                    <i className={`${cat.icon} text-sm`}></i>
                  </div>
                  <h3 className="text-base font-bold font-heading text-foreground-900">{cat.name}</h3>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}